// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__e6CY2","block":"styles_block__7Eq1s"};